import * as React from "react"
import type { EntityTransaction, Transaction } from "@digits-graphql/frontend/graphql-bearer"
import { VTable } from "@digits-shared/components/UI/VirtualizedTable/VTable"
import type { ColumnDef } from "@tanstack/react-table"
import { EmptyTransactionsTable } from "src/frontend/components/Shared/Transactions/TableCells/EmptyTransactionsTable"
import { TABLE_STYLE } from "src/frontend/components/Shared/Transactions/transactionsTableStyles"
import { type TransactionsTableProps } from "src/frontend/components/Shared/Transactions/types"
import { useTableRowSelection } from "src/frontend/components/Shared/Transactions/Updates/useTableRowSelection"

/*
  INTERFACES
*/
interface TableProps<META extends object = {}> extends TransactionsTableProps {
  columns: ColumnDef<Transaction | EntityTransaction>[]
  meta?: META
}

/*
  COMPONENTS
*/

export const VTransactionsTable = <META extends object>({
  ref,
  className,
  columns,
  meta,
  transactions,
  loading,
  collapsed,
  sorting,
  onSortingChange,
}: TableProps<META>) => {
  const {
    estimateRowSize,
    getRowId,
    getRowClassName,
    rowSelectionDisabled,
    rowSelection,
    onRowSelectionChange,
    onRowClick,
  } = useTableRowSelection(transactions)

  return (
    <VTable
      ref={ref}
      className={className}
      css={TABLE_STYLE}
      meta={meta}
      loading={loading}
      collapsed={collapsed}
      data={transactions || []}
      columns={columns}
      estimateRowSize={estimateRowSize}
      getRowId={getRowId}
      getRowClassName={getRowClassName}
      onRowClick={onRowClick}
      state={{
        sorting,
        rowSelection,
      }}
      enableRowSelection={!rowSelectionDisabled}
      manualSorting={true}
      enableSortingRemoval={false}
      onSortingChange={onSortingChange}
      onRowSelectionChange={onRowSelectionChange}
      EmptyTable={EmptyTransactionsTable}
    />
  )
}
